import {useQuery, useMutation, useQueryClient} from '@tanstack/react-query';
import {
  billingApi,
  PaymentMethod,
  CreateSetupIntentResponse,
} from 'services/billingApi';

export const PAYMENT_METHODS_QUERY_KEY = ['billing', 'payment-methods'];

export const usePaymentMethods = () =>
  useQuery({
    queryKey: PAYMENT_METHODS_QUERY_KEY,
    queryFn: () => billingApi.listPaymentMethods(),
    staleTime: 30000,
  });

export const useCreatePaymentMethodSetupIntent = () =>
  useMutation<CreateSetupIntentResponse>({
    mutationFn: () => billingApi.createSetupIntent(),
  });

export const useSetDefaultPaymentMethod = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (paymentMethodId: string) =>
      billingApi.setDefaultPaymentMethod(paymentMethodId),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: PAYMENT_METHODS_QUERY_KEY});
    },
  });
};

export const useDeletePaymentMethod = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (paymentMethodId: string) =>
      billingApi.deletePaymentMethod(paymentMethodId),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: PAYMENT_METHODS_QUERY_KEY});
    },
  });
};

export type PaymentMethodRow = PaymentMethod & {
  label?: string;
  type?: string;
  default?: boolean;
  details?: {
    card_number: string;
  };
};
